export const paymentMethodEn = {
  Dashboard: `Dashboard`,
  catalog: `Catalog`,
  payment_methods: `Payment Methods`,
  payment_method: `Payment Method`,
  add_payment_method: `Add Payment Method`,
  edit_payment_method: `Edit Payment Method`,
  delete_payment_method: `Delete Payment Method`,
  delete_payment_method_description: `Are you sure you want to delete this payment method? This action cannot be undone.`,
  code: `Code`,
  name: `Name`,
  actions: `Actions`,
  search: `Search`,
  search_placeholder: `Search by code or name`,
  filter_payment_methods: `Filter Payment Methods`,
  filter_payment_methods_subtitle: `Narrow down the payment methods list`,
  edit: `Edit`,
  delete: `Delete`,
  cancel: `Cancel`,
  add: `Add`,
  update: `Update`,
  code_required: `Code is required`,
  name_required: `Name is required`,
  no_payment_methods_found: `No payment methods found`,
  payment_method_created_successfully: `Payment method created successfully`,
  payment_method_updated_successfully: `Payment method updated successfully`,
  payment_method_deleted_successfully: `Payment method deleted successfully`,
  something_went_wrong: `Something went wrong`,
  organization_not_found: `Organization not found for the current user`,
  payment_method_code_required: `Payment method code is required`,
  payment_method_name_required: `Payment method name is required`,
  payment_method_code_duplicate: `A payment method with this code already exists`,
  payment_method_not_found: `Payment method not found`,
  not_allowed_to_update_payment_method: `You are not allowed to update this payment method`,
  not_allowed_to_delete_payment_method: `You are not allowed to delete this payment method`,
  payment_method_listing_max_100_allowed: `A maximum of 100 payment methods can be listed per page`,
};
